import React from 'react';
import StrapiForm from 'gatsby-theme-forms/src/components/form';
import Intro from '../components/intro';

const Header = ({
  title = '',
  text = '',
  image,
  backgroundImage,
  button,
  strapiFormForm,
  fullWidth,
}) => (
  <Intro
    title={title}
    fullWidth={fullWidth}
    content={text}
    contentAs="div"
    image={image}
    backgroundImage={backgroundImage}
    button={button}
    form={strapiFormForm && (
      <StrapiForm
        horizontal={strapiFormForm.components.length === 1}
        {...strapiFormForm}
      />
    )}
  />
);

export default Header;
